import { render, staticRenderFns } from "./AllStatusReport.vue?vue&type=template&id=629a13ab&scoped=true"
import script from "./AllStatusReport.vue?vue&type=script&lang=js"
export * from "./AllStatusReport.vue?vue&type=script&lang=js"
import style0 from "./AllStatusReport.vue?vue&type=style&index=0&id=629a13ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a13ab",
  null
  
)

export default component.exports